import React from "react";
import SingleAircraftTypeContent from "../components/aircraftTypes/single-aircraftType-content";

const SingleAircraftType = () => {
  return <SingleAircraftTypeContent />;
};

export default SingleAircraftType;
